import { ImageLoaderProps } from 'next/image';
import { cloudflare } from '../utils';

const imageHost = process.env.NEXT_PUBLIC_UMBRACO_IMAGES_URL || '';

export function umbracoLoader(props: ImageLoaderProps) {
    return cloudflare({ ...props, imageHost });
}
